import { gql } from 'apollo-angular';
import { Linkable } from '../../../entities/entityLink/linkable';

export const GET_LINKABLES_QUERY = gql`
  query getLinkables($filter: LinkableFilter) {
    getLinkables(filter: $filter){
      id
      text
      entityType
    }
  }
`;

export interface GetLinkablesResponse {
  getLinkables: Linkable[];
}

export const LINK_ENTITIES_MUTATION = gql`
  mutation LinkEntities($input: EntityLinkInput!) {
    linkEntities(input: $input) {
      id
    }
  }
`;

export interface LinkEntitiesResponse {
  linkEntities: any; // Replace with your EntityLink interface
}

export const UNLINK_ENTITIES_MUTATION = gql`
  mutation unlinkEntities($entityLinkId: UUID!) {
    unlinkEntities(entityLinkId: $entityLinkId)
  }
`;

export interface UnlinkEntitiesResponse {
  unlinkEntities: boolean;
}
